 import React, { useState, useEffect } from "react";
import Select from "react-select";
import api from "../api/api"; // ✅ ensure correct path

const VendorTeam = () => {
  const [vendorOptions, setVendorOptions] = useState([]);
  const [vendors, setVendors] = useState([]); // ✅ Vendor team list
  const [showPopup, setShowPopup] = useState(false);
  const [editingVendor, setEditingVendor] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 6;

  const [newVendor, setNewVendor] = useState({
    VTID: 0,
    vid: 0,
    vcode: "",
    supplierName: "",
    empName: "",
    designation: "",
    active: false,
  });

  const designationOptions = [
    { value: "Manager", label: "Manager" },
    { value: "Supervisor", label: "Supervisor" },
    { value: "Staff", label: "Staff" },
  ];

  // ✅ Fetch supplier list
  const fetchVendors = async () => {
    try {
      const userName = sessionStorage.getItem("userName");
      const databaseKey = sessionStorage.getItem("databaseKey");

      const res = await api.GetSupplierList_API(userName, databaseKey);
      const vendorList = res?.GetSupplierList_API_APIjs?.Table || [];

      const options = vendorList.map((v) => ({
        value: v.Vid,
        label: v.Vname,
        Vid: v.Vid,
        Vcode: v.Vcode,
        Vname: v.Vname,
      }));

      setVendorOptions(options);

      // ✅ Fetch vendor team list
      await fetchVendorTeamList(userName, databaseKey);
    } catch (err) {
      console.error("❌ Error fetching vendors:", err);
    }
  };

  // ✅ Fetch vendor team list
  const fetchVendorTeamList = async (userName, databaseKey) => {
    try {
      const res = await api.VendorsTeamList_API(userName, databaseKey);
      const teamList = res?.VendorsTeamList_API_APIjs?.Table || [];

      const formattedList = teamList.map((t) => ({
        VTID: t.VTID,
        vid: t.Vid,
        supplierName: t.Vname,
        empName: t.EmpName,
        designation: t.Designation,
        active: t.Active === 1,
        userName: t.UserName,
      }));

      setVendors(formattedList);
    } catch (err) {
      console.error("❌ Error fetching vendor team list:", err);
    }
  };

  useEffect(() => {
    fetchVendors();
  }, []);

  // ✅ New button
  const handleNew = () => {
    setEditingVendor(null);
    setNewVendor({
      VTID: 0,
      vid: 0,
      vcode: "",
      supplierName: "",
      empName: "",
      designation: "",
      active: false,
    });
    setShowPopup(true);
  };

  // ✅ Edit button
  const handleEdit = (vendor) => {
    setEditingVendor(vendor);
    setNewVendor({ ...vendor });
    setShowPopup(true);
  };

  // ✅ Close popup
  const handleClose = () => {
    setShowPopup(false);
    setEditingVendor(null);
  };

  // ✅ Save vendor team
  const handleSave = async () => {
    if (!newVendor.supplierName || !newVendor.empName || !newVendor.designation) {
      alert("⚠️ Please fill all required fields!");
      return;
    }

    try {
      setLoading(true);

      const databaseKey = sessionStorage.getItem("databaseKey");
      const userName = sessionStorage.getItem("UserName") || "admin";
      const Sp_SqlAction = editingVendor ? "UPDATE" : "INSERT";

      const selectedVendor = vendorOptions.find(
        (v) => v.label === newVendor.supplierName || v.value === newVendor.vid
      );

      const vid = selectedVendor?.Vid || newVendor.vid || 0;
      const vcode = selectedVendor?.Vcode || newVendor.vcode || "";
      const vname = selectedVendor?.Vname || newVendor.supplierName || "";

      console.log("🟡 Saving vendor team:", {
        Sp_SqlAction,
        VTID: editingVendor?.VTID || 0,
        vid,
        vcode,
        vname,
        empName: newVendor.empName,
        designation: newVendor.designation,
        active: newVendor.active ? 1 : 0,
        UserName: userName,
        databaseKey,
      });

      const res = await api.SaveVendorsTeam_API(
        Sp_SqlAction,
        editingVendor?.VTID || 0,
        vid,
        vcode,
        vname,
        newVendor.empName,
        newVendor.designation,
        newVendor.active ? 1 : 0,
        userName,
        databaseKey
      );

      const message =
        res?.SaveVendorsTeam_APIjs?.[0]?.Message ||
        res?.data?.SaveVendorsTeam_APIjs?.[0]?.Message ||
        res?.Message ||
        "";

      if (message.toLowerCase().includes("already")) {
        alert("❌ " + message);
        return;
      }

      alert("✅ " + (message || "Saved successfully!"));

      // ✅ Refresh team list
      await fetchVendorTeamList(userName, databaseKey);
      setShowPopup(false);
      setEditingVendor(null);
    } catch (err) {
      console.error("❌ Error saving vendor team:", err);
      alert("❌ Error saving vendor team: " + (err.message || err));
    } finally {
      setLoading(false);
    }
  };

  // ✅ Search filter
  const filteredVendors = vendors.filter(
    (v) =>
      v.supplierName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      v.empName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      v.designation?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // ✅ Pagination
  const totalPages = Math.ceil(filteredVendors.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const paginatedVendors = filteredVendors.slice(startIndex, startIndex + pageSize);

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-full mx-auto bg-white rounded-lg shadow-lg">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-400 to-blue-500 text-white p-4 rounded-t-lg flex justify-between items-center">
          <h1 className="text-xl font-bold">Vendor Team</h1>
          <button
            onClick={handleNew}
            className="bg-white/20 hover:bg-white/30 text-white px-3 py-2 rounded-lg font-semibold flex items-center space-x-1 transition-all duration-200"
            title="Add New Vendor"
          >
            <span>➕</span>
            <span>New</span>
          </button>
        </div>

        {/* Search in Header */}
        <div className="p-4 bg-gradient-to-r from-slate-50 to-slate-100 border-b-2 border-slate-200">
          <input
            type="text"
            placeholder="🔍 Search Vendor..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full px-3 py-2 border border-slate-300 rounded focus:ring-1 focus:ring-blue-400 focus:border-blue-400"
          />
        </div>

        {/* Table */}
        <div className="p-6">
          <div className="overflow-x-auto shadow-2xl rounded-2xl">
            <div className="max-h-[500px] overflow-y-auto">
              <table className="min-w-full bg-white border-collapse">
                <thead className="bg-gradient-to-r from-slate-700 to-slate-800 sticky top-0 z-10">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-bold text-white border-r border-slate-600">#</th>
                    <th className="px-4 py-3 text-left text-sm font-bold text-white border-r border-slate-600">Supplier Name</th>
                    <th className="px-4 py-3 text-left text-sm font-bold text-white border-r border-slate-600">Emp Name</th>
                    <th className="px-4 py-3 text-left text-sm font-bold text-white border-r border-slate-600">Designation</th>
                    <th className="px-4 py-3 text-left text-sm font-bold text-white border-r border-slate-600">Active</th>
                    <th className="px-4 py-3 text-left text-sm font-bold text-white">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedVendors.length > 0 ? (
                    paginatedVendors.map((vendor, index) => (
                      <tr key={vendor.VTID || index} className={`transition-all duration-200 border-b border-slate-200 ${
                        index % 2 === 0
                          ? 'bg-white hover:bg-slate-100'
                          : 'bg-slate-50 hover:bg-slate-100'
                      }`}>
                        <td className="px-4 py-3 text-sm font-semibold text-slate-800 border-r border-slate-200">{startIndex + index + 1}</td>
                        <td className="px-4 py-3 text-sm text-slate-700 border-r border-slate-200 font-medium">{vendor.supplierName}</td>
                        <td className="px-4 py-3 text-sm text-slate-700 border-r border-slate-200">{vendor.empName}</td>
                        <td className="px-4 py-3 text-sm text-slate-700 border-r border-slate-200">{vendor.designation}</td>
                        <td className="px-4 py-3 text-sm text-slate-700 border-r border-slate-200">{vendor.active ? "✅ Active" : "❌ Inactive"}</td>
                        <td className="px-4 py-3 text-center">
                          <button
                            onClick={() => handleEdit(vendor)}
                            className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white px-3 py-1 rounded-lg font-semibold flex items-center space-x-1 transition-all duration-200 shadow-sm hover:shadow-md"
                          >
                            <span>✏️</span>
                            <span>Edit</span>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="px-6 py-12 text-center text-slate-500 bg-slate-100">
                        <div className="flex flex-col items-center space-y-2">
                          <span className="text-4xl">📭</span>
                          <span>No matching records found</span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          <div className="flex justify-between items-center mt-8 px-4">
            <div className="flex items-center space-x-3">
              <button
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 1}
                className={`px-5 py-3 rounded-xl font-bold transition-all duration-200 flex items-center space-x-2 ${
                  currentPage === 1
                    ? 'bg-slate-300 text-slate-500 cursor-not-allowed'
                    : 'bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white shadow-lg hover:shadow-xl transform hover:scale-105'
                }`}
              >
                <span className="text-lg">⬅️</span>
                <span>Previous</span>
              </button>

              <div className="flex items-center space-x-2">
                <span className="text-slate-600 font-semibold">Page</span>
                <span className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-4 py-2 rounded-xl font-bold shadow-md">
                  {currentPage} of {totalPages}
                </span>
              </div>

              <button
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`px-5 py-3 rounded-xl font-bold transition-all duration-200 flex items-center space-x-2 ${
                  currentPage === totalPages
                    ? 'bg-slate-300 text-slate-500 cursor-not-allowed'
                    : 'bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white shadow-lg hover:shadow-xl transform hover:scale-105'
                }`}
              >
                <span>Next</span>
                <span className="text-lg">➡️</span>
              </button>
            </div>

            <div className="text-sm text-slate-500 font-medium">
              Showing {startIndex + 1}-{Math.min(startIndex + pageSize, filteredVendors.length)} of {filteredVendors.length} records
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Popup Modal */}
      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-2xl p-5 w-[400px]">
            <h3 className="text-base font-semibold text-gray-700 mb-3 text-center">
              {editingVendor ? "Edit Vendor" : "Add New Vendor"}
            </h3>

            <div className="space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Vendor Name:</label>
                <Select
                  options={vendorOptions}
                  value={
                    vendorOptions.find(
                      (v) =>
                        v.value === newVendor.vid ||
                        v.label === newVendor.supplierName
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    setNewVendor({
                      ...newVendor,
                      supplierName: selectedOption.label,
                      vid: selectedOption.Vid,
                      vcode: selectedOption.Vcode,
                    })
                  }
                  placeholder="Select Vendor"
                  isSearchable
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "35px",
                      fontSize: "14px",
                    }),
                  }}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Emp Name:</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-1 focus:ring-blue-400 focus:border-blue-400"
                  value={newVendor.empName}
                  onChange={(e) =>
                    setNewVendor({ ...newVendor, empName: e.target.value })
                  }
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Designation:</label>
                <Select
                  options={designationOptions}
                  value={designationOptions.find(
                    (d) => d.value === newVendor.designation
                  )}
                  onChange={(selectedOption) =>
                    setNewVendor({
                      ...newVendor,
                      designation: selectedOption.value,
                    })
                  }
                  placeholder="Select Designation"
                  isSearchable
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "35px",
                      fontSize: "14px",
                    }),
                  }}
                />
              </div>

              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={newVendor.active}
                  onChange={(e) =>
                    setNewVendor({ ...newVendor, active: e.target.checked })
                  }
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label className="ml-2 block text-sm text-gray-900">Active</label>
              </div>
            </div>

            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={handleClose}
                className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                disabled={loading}
                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 disabled:opacity-50"
              >
                {loading ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


export default VendorTeam;
